/** All TanStack Query keys in one place so invalidation is never guesswork. */
export const QueryKeys = {
  Me: ['me'] as const,
  Projects: ['projects'] as const,
  Project: (id: string) => ['projects', id] as const,
  ProjectSummary: (id: string) => ['projects', id, 'summary'] as const,
  ProjectContracts: (id: string) => ['projects', id, 'contracts'] as const,
  LookupEmployees: (q: string) => ['lookup', 'employees', q] as const,
  LookupCustomers: (q: string) => ['lookup', 'customers', q] as const,
  LookupSuppliers: (q: string) => ['lookup', 'suppliers', q] as const,
  TimeLogRates: ['timelog-rates'] as const,
  RpDepartments: ['rp', 'departments'] as const,
  RpRoles: ['rp', 'roles'] as const,
  RpResources: ['rp', 'resources'] as const,
  RpProjects: ['rp', 'projects'] as const,
  /** Prefix ['rp', 'planner'] invalidates every planner read at once. */
  RpPlanner: (from: string, to: string, granularity: string, mode: string) =>
    ['rp', 'planner', from, to, granularity, mode] as const,
  RpAvailability: (from: string, to: string) => ['rp', 'availability', from, to] as const,
  RpResourceSearch: (q: string) => ['rp', 'resource-search', q] as const,
};
